import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { BehaviorSubject } from 'rxjs';
import { getDocument } from 'ssr-window';

interface IIssue {
  image: string;
  header: string;
  description: string;
  length: string;
  video: string;
}

const fade = trigger('fade', [
  state('void', style({ opacity: 0 })),

  transition('void <=> *', [animate(300)]),
]);

const getYoutubeId = (youtubeLink: string) => {
  return youtubeLink.split('=').pop();
};

const getYoutubeThumbnail = (id: string) =>
  `http://i3.ytimg.com/vi/${id}/hqdefault.jpg`;

const getYoutubeEmbedLink = (id: string, enableLoop = true) => {
  if (enableLoop) {
    return `https://www.youtube-nocookie.com/embed/${id}?playlist=${id}&autoplay=1&mute=1&controls=1&loop=1`;
  }
  return `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&mute=1&controls=1`;
};

@Component({
  selector: 'app-youtube-modal',
  templateUrl: './youtube-modal.component.html',
  styleUrls: ['./youtube-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [fade],
})
export class YoutubeModalComponent {
  public youtubeId?: string;
  youtubeThumbnail$ = new BehaviorSubject<string | undefined>(undefined);
  youtubeEmbedLink$ = new BehaviorSubject<SafeUrl | undefined>(undefined);

  private _youtubeLink?: string;
  @Input() set youtubeLink(link: string | undefined) {
    this._youtubeLink = link;
    if (this.youtubeLink) {
      this.youtubeId = getYoutubeId(this.youtubeLink);

      if (this.youtubeId) {
        this.youtubeThumbnail$.next(getYoutubeThumbnail(this.youtubeId));
      }
    } else {
      this.youtubeThumbnail$.next(undefined);
    }
  }

  get youtubeLink() {
    return this._youtubeLink;
  }

  @Input() thumbnail?: string;
  @Input() linkModal?: boolean = false;

  constructor(private sanitizer: DomSanitizer) {}

  showVideo() {
    getDocument().body.style.overflow = 'hidden';
    this.youtubeEmbedLink$.next(
      this.sanitizer.bypassSecurityTrustResourceUrl(
        getYoutubeEmbedLink(this.youtubeId || '')
      )
    );
  }
  closeDialog() {
    getDocument().body.style.overflow = '';
    this.youtubeEmbedLink$.next(undefined);
  }
}
